import React from "react";
import OfferDetailsBase from "./OfferDetailsBase";

export default function ServiceDetails() {
  return <OfferDetailsBase kind="service" />;
}
